import styled, { css } from "styled-components";

export const ListButton = styled.button<{
  isActive: boolean;
  isLastChild: boolean;
}>`
  background-color: transparent;
  border: none;
  position: relative;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--fd-space-space-3);
  gap: var(--fd-space-space-2);
  cursor: pointer;

  @media (hover: hover) {
    &:hover {
      background-color: var(--fd-colors-background-hover);
    }
  }

  ${({ isLastChild }) =>
    !isLastChild &&
    css`
      border-bottom: 1px solid var(--fd-colors-border-subtle);
    `};

  ${({ isActive }) =>
    isActive &&
    css`
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 3px;
        z-index: 1;
        background-color: var(--fd-colors-border-active);
      }
    `}
`;
